import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';

export const ApprovalAmountCell = ({ value, data }: ICellRendererParams) => {
  const { formatCurrency } = useNumberFormat();

  const allowedStatuses = [
    APPLICATION_STATUS.offered,
    APPLICATION_STATUS.conditional_offer,
    APPLICATION_STATUS.funded,
    APPLICATION_STATUS.expired,
    APPLICATION_STATUS.talking_to_customer,
    APPLICATION_STATUS.offer_rejected,
    APPLICATION_STATUS.offer_revoked,
  ];

  if (value && allowedStatuses.includes(data.status)) {
    return <div>{formatCurrency(value)}</div>;
  }

  return '-';
};
